import * as React from "react";

import { DropdownContext, IndexedObject } from "./DropdownProvider";
import { DropdownMenuItem } from "./DropdownMenuItem";
import { DropdownMenuLinkItem } from "./DropdownMenuLinkItem";
import { DropdownMenuNoResults } from "./DropdownMenuNoResults";

type DropdownMenuItemChild = React.ReactElement<typeof DropdownMenuItem
    | typeof DropdownMenuLinkItem | typeof DropdownMenuNoResults>[];

interface DropdownMenuItemsProps {
    children?: DropdownMenuItemChild;
}

interface DropdownMenuItemsChildren {
    [key: string]: React.ReactElement;
}

export const DropdownMenuItems = (props: React.PropsWithChildren<DropdownMenuItemsProps>) => {
    const { children } = props;
    const { classes, dropdownItems } = React.useContext(DropdownContext);
    const { dropdownItemComponent, noResultsComponent } = React.Children.toArray(children)
        .reduce<DropdownMenuItemsChildren>((childComponents, child): DropdownMenuItemsChildren => {
            const { type } = child as React.ReactElement;

            if (type === DropdownMenuItem || type === DropdownMenuLinkItem) {
                return {
                    ...childComponents,
                    dropdownItemComponent: child as React.ReactElement
                };
            } if (type === DropdownMenuNoResults) {
                return {
                    ...childComponents,
                    noResultsComponent: child as React.ReactElement
                };
            }

            return childComponents;
        }, {} as { [key: string]: any; });

    return (
        <>
            {dropdownItems.length > 0 ? (
                <ul className={classes?.menuList}>
                    {dropdownItems.slice(0, 10).map((item: IndexedObject, index: number) => React.cloneElement(
                        dropdownItemComponent, { item, index, key: item.value }
                    ))}
                </ul>
            ) : noResultsComponent}
        </>
    );
};
